import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-time-register",
  "use": "icon-time-register-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-time-register\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.667 9A6.667 6.667 0 1 1 2.333 9a6.667 6.667 0 0 1 13.334 0Zm1.666 0A8.333 8.333 0 1 1 .667 9a8.333 8.333 0 0 1 16.666 0Zm-7.5-3.333a.833.833 0 1 0-1.666 0v4.166c0 .316.178.604.46.746l2.5 1.666a.833.833 0 0 0 .746-1.49l-2.04-1.437V5.667Z\" fill=\"#4C556C\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol